export default function FaqSection() {
  const faqs = [
    {
      q: '迷妹漫画是否真的完全免费？',
      a: '是的，迷妹漫画始终坚持全本免费阅读的理念。平台上所有漫画资源均可免费在线观看，无需付费或订阅会员，让每一位漫画爱好者都能零花费畅享优质漫画内容。',
    },
    {
      q: '如何在手机上获得最佳阅读体验？',
      a: '我们推荐下载迷妹漫画APP，专为移动端优化的下拉式竖屏滚动阅读模式，支持离线缓存、夜间模式和智能书签功能，让你随时随地享受如翻阅纸质漫画般的流畅体验。',
    },
    {
      q: '网站上的漫画多久更新一次？',
      a: '迷妹漫画保持每日稳定更新。连载中的热门作品通常保持与官方同步的更新频率，完结作品已全部收录。你可以在"最近更新"模块中查看当日和近期的所有更新动态。',
    },
    {
      q: '平台上有哪些类型的漫画？',
      a: '迷妹漫画涵盖日本漫画、韩国漫画和国产漫画三大品类，包括恋爱、热血、悬疑、古风、奇幻、治愈、校园等丰富题材。无论你是哪种类型的漫迷，都能在这里找到心仪的作品。',
    },
    {
      q: '阅读时需要注册账号吗？',
      a: '不需要。迷妹漫画支持游客直接阅读，无需注册即可畅享全部漫画内容。如果你希望跨设备同步阅读进度和收藏，可以选择注册账号获得更好的体验。',
    },
    {
      q: '如何向平台投稿或推荐漫画？',
      a: '我们非常欢迎创作者和漫迷的投稿与推荐。你可以通过"联系我们"模块中的邮箱发送作品或推荐信息，我们的编辑团队会认真审阅每一份来稿并及时回复。',
    },
  ];

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">常见问答</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            关于迷妹漫画的常见问题，帮你快速了解平台功能与使用方式
          </p>
        </div>

        <div className="max-w-3xl mx-auto grid gap-3 md:gap-4">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-background-50 rounded-xl border border-background-200/70 p-5 md:p-6">
              <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 mb-2 flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-primary-100 flex items-center justify-center text-xs font-bold text-primary-600 mt-0.5">Q</span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-9">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}